import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export default function BusinessStatement() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [60, -60]);

  return (
    <section ref={ref} className="relative overflow-hidden bg-[#0B1220] py-24 lg:py-36 text-white" data-testid="business-statement">
      <div className="absolute inset-0 dot-pattern opacity-[0.06]" aria-hidden="true" />
      <motion.div style={{ y }} className="ad-container relative">
        <div className="max-w-4xl">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#00C7D9]">The shift</span>
          <h2 className="mt-6 display-lg">
            <span className="block">Your data should do more than report the past.</span>
            <span className="mt-2 block text-white/40">
              It should help you shape <span className="text-gradient">what's next.</span>
            </span>
          </h2>
        </div>
      </motion.div>
    </section>
  );
}
